import { useAlertUiTranslation } from '../../../../../../ui/hooks';
import { useAlertsUrl } from '../../../../../../ui/hooks/useAlertsUrl';
import { AlertConfigContext } from '../../../../../../ui/providers';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { allowUserSendMessages } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import ShortcutOutlinedIcon from '@mui/icons-material/ShortcutOutlined';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { showNotificationDialog } from '../../../../alerts';
import { useInboxClient } from '../../../hooks';
export const InboxNotificationActions = ({ notification, onReload, onCloseDialog }) => {
    const { t } = useAlertUiTranslation();
    const { inboxPanelCustomization } = React.useContext(AlertConfigContext);
    const alertsSentUrl = useAlertsUrl('sent');
    const userState = useUserState();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const inboxClient = useInboxClient();
    const allowSendMessages = allowUserSendMessages(userState);
    return (React.createElement(Box, { sx: {
            alignSelf: 'self-start',
            display: 'flex',
            gap: 1,
            color: themeColors.primary.base,
            alignItems: 'center',
        } },
        React.createElement(Tooltip, { title: t('common.archive') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showConfirmDialog({
                        title: t('archiveAlertsDialog.title', { count: 1 }),
                        content: t('archiveAlertsDialog.message', { count: 1, page: 'Inbox Archived' }),
                        confirmLabel: t('common.archive'),
                        onConfirm: () => {
                            inboxClient
                                .archive([notification.id])
                                .then(() => {
                                onReload(true);
                                onCloseDialog === null || onCloseDialog === void 0 ? void 0 : onCloseDialog();
                                showAlertSnackbar({
                                    message: t('inbox.archive.success', { count: 1 }),
                                    autoHideDuration: 1000,
                                    type: 'success',
                                });
                            })
                                .catch(handleErrorSnackbar);
                        },
                    });
                } },
                React.createElement(ArchiveOutlinedIcon, null))),
        allowSendMessages && (React.createElement(Tooltip, { title: t('common.forward') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    var _a, _b;
                    showNotificationDialog({
                        mode: 'notification',
                        reviewFormHeader: t('pages.newFromTemplate.reviewAndSend'),
                        wizardHeader: t('pages.newFromTemplate.createNotification'),
                        dialogStep: 'wizard',
                        partialAlert: {
                            subject: t('common.forwardSubjectPrefix') + ' ' + notification.subject,
                            htmlMessage: t('common.forwardHtmlMessagePrefix') + notification.htmlMessage,
                            messageType: notification.labels && ((_a = notification.labels) === null || _a === void 0 ? void 0 : _a.length) > 0 ? notification.labels[0] : undefined,
                            sendType: 'immediately',
                            channels: ['inbox'],
                            deliveryOrder: { deliveryMode: 'blast' },
                            customAlertData: ((_b = notification.additionalData) === null || _b === void 0 ? void 0 : _b.customAlertData) != null
                                ? JSON.parse(notification.additionalData.customAlertData)
                                : undefined,
                        },
                        onSubmitSuccess: (_data, onClose) => {
                            showAlertSnackbar({
                                message: t('pages.edit.snackbar.notification.sent'),
                                type: 'success',
                                autoHideDuration: 1000,
                            });
                            onClose();
                            onCloseDialog === null || onCloseDialog === void 0 ? void 0 : onCloseDialog();
                            navigationContext.navigate(() => navigate(alertsSentUrl));
                        },
                    });
                } },
                React.createElement(ShortcutOutlinedIcon, null)))),
        (inboxPanelCustomization === null || inboxPanelCustomization === void 0 ? void 0 : inboxPanelCustomization.additionalActions) && inboxPanelCustomization.additionalActions(notification)));
};
